import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import FormContainer from '../layout/form-container';

const LogoutWisemapping = (): React.ReactElement => {
  const location = useLocation();
  const cookies = new Cookies();
  
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const retrunUrl = queryParams.get('redirect');

    cookies.remove('jwt-auth-token', { path: '/' });
    window.location.href = retrunUrl || 'https://thinkmapping.com';
  }, [location.search]);

  return (
    <div>
     <FormContainer>
        <h1>Se déconnecter</h1>
        <img src="thinkmapping-logo.png" />
        <img src="loader.gif" />
      </FormContainer>
    </div>
  );
};

export default LogoutWisemapping;